import React from 'react'
import { useIntl } from 'react-intl'
import {
  Tooltip,
  TooltipProps
} from '@contrast-security-inc/design-system-popovers'
import { Text } from '@contrast-security-inc/design-system-typography'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { css } from '@emotion/css'
import { ellipsis } from 'polished'

const targetUrlCss = css`
  color: ${theme.color.neutral60};
  padding-bottom: 7px;
  ${ellipsis()}
`

interface UrlTooltipProps {
  url: string
  placement?: TooltipProps['placement']
}

export const UrlWithTooltip: React.FC<UrlTooltipProps> = ({
  url,
  placement = 'top'
}) => {
  return (
    <Tooltip placement={placement} body={<UrlTooltip url={url} />}>
      <Text font="body" className={targetUrlCss}>
        {url}
      </Text>
    </Tooltip>
  )
}

const UrlTooltip: React.FC<Pick<UrlTooltipProps, 'url'>> = ({ url }) => {
  const intl = useIntl()

  return (
    <div
      className={css`
        max-width: 325px;
        word-break: break-all;
        word-break: break-word;
      `}
    >
      <Text font="metadataStrong">
        {intl.formatMessage({ id: 'title_url' })}
      </Text>
      {`: ${url}`}
    </div>
  )
}
